import { AlertCircle, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

export const ErrorCard = ({ message, onReset }) => (
  <section data-testid="error-alert" className="rounded-2xl border border-red-200 bg-red-50/60 p-6 sm:p-10 fade-up">
    <div className="flex items-start gap-3">
      <AlertCircle className="w-6 h-6 text-red-600 shrink-0" />
      <div>
        <h2 className="font-display text-xl font-bold text-slate-900">Conversione non riuscita</h2>
        <p data-testid="error-message" className="mt-2 text-sm text-slate-700">{message}</p>
        <p className="mt-2 text-xs text-slate-500">Suggerimento: controlla che il PDF non sia protetto da password e che la scansione sia leggibile.</p>
      </div>
    </div>
    <Button data-testid="error-retry-button" onClick={onReset} className="mt-6 h-11 px-6 rounded-full bg-slate-900 hover:bg-slate-800 btn-lift">
      <RotateCcw className="w-4 h-4 mr-2" /> Riprova con un altro file
    </Button>
  </section>
);
